const config = {};

//config.ESTORIS_BASE_PATH = 'http://localhost:15536'; // 'https://qa.storis.com/testwin2016serv-qa10.2.0.16-42.3|localhost:8001|15536';
config.ESTORIS_BASE_PATH = "http://127.0.0.1:65283";

// The local cache should be invalidated after 5 minutes (in milliseconds).
config.MAX_CACHE_AGE = 300000;

// go back to the homepage after 5 minutes of inactivity
config.MAX_INACTIVE_TIME = 300000;

// Refetch brandInfo after 3 hours (in milliseconds)
config.MAX_BRAND_INFO_CACHE_TIME = 10800000;

// set store
config.STORES = `[{"Name":"Warehouse 66","AdminComment":null,"AddressId":8,"Id":1},{"Name":"Warehouse 88","AdminComment":null,"AddressId":186,"Id":2}]`;

// Set welcome images for local development. Resolves to /images/thumbs/random-image-name.png when running in production using a combination of database tables and the FSO.
config.WELCOME_IMAGES = `[
	{"size":"S","url":"${config.ESTORIS_BASE_PATH}/plugins/Kiosk.STORIS/content/homeImages/SleepScreenKiosk_1_S.png"},
	{"size":"S","url":"${config.ESTORIS_BASE_PATH}/plugins/Kiosk.STORIS/content/homeImages/SleepScreenKiosk_2_S.png"},
	{"size":"M","url":"${config.ESTORIS_BASE_PATH}/plugins/Kiosk.STORIS/content/homeImages/SleepScreenKiosk_1_M.png"},
	{"size":"M","url":"${config.ESTORIS_BASE_PATH}/plugins/Kiosk.STORIS/content/homeImages/SleepScreenKiosk_2_M.png"},
	{"size":"L","url":"${config.ESTORIS_BASE_PATH}/plugins/Kiosk.STORIS/content/homeImages/SleepScreenKiosk_1_L.png"},
	{"size":"L","url":"${config.ESTORIS_BASE_PATH}/plugins/Kiosk.STORIS/content/homeImages/SleepScreenKiosk_2_L.png"}
]`;

// set default colors
config.COLORS = {
	DarkAccent: "",
	Primary: "",
	Secondary: "",
	ProductDetailSalePrice: "",
	ProductCategoryCardSalePrice: "",
	Text: "",
};

// set default product settings
config.PRODUCT = {
	ShowCurrentPrice: true,
	ShowInStock: true,
	ShowMsrp: true,
	ShowOnDisplay: true,
	ShowPriceDecimal: true,
	ShowReviews: true,
	ShowSku: true,
	ShowVendor: true,
	SliderShowNav: true
};

// set default general settings
config.GENERAL = {
	ShowLoginRegistration: true,
	ShowCart: true,
	CategoryCardView: false,
};

config.SingleSignOn = {
	STORISSingleSignOnEnabled: false,
	ExtLoginJWTToken: null,
	ExtLoginEmail: null,
	ExtLoginName: null,
	ShowEmailCart: false,
};

config.ProductAddOnLabel = "Items in the Collection";

// production settings specified by config.js included before kiosk bundle.js
if (process.env.NODE_ENV === "production" && window.kioskSettings) {
	Object.keys(window.kioskSettings).forEach((setting) => {
		config[setting] = window.kioskSettings[setting];
	});

	config.COLORS = JSON.parse(config.COLORS);
	config.PRODUCT = JSON.parse(config.PRODUCT);
	config.GENERAL = JSON.parse(config.GENERAL);
	config.SingleSignOn = JSON.parse(config.SingleSignOn);
	window.kioskSettings.version = "v0.9.0";
}

// for testing
if (process.env.NODE_ENV === "test") {
	config.COLORS = {
		DarkAccent: "#808080",
		Primary: "#0000ff",
		Secondary: "#ffa500",
		ProductDetailSalePrice: "#ff0000",
		ProductCategoryCardSalePrice: "#ffffff",
		Text: "#000000",
	};
	config.SET_ITEM_ENABLED = true;
	config.STORES = `[{"Name":"Warehouse 100","AdminComment":null,"AddressId":8,"Id":3},{"Name":"Warehouse 66","AdminComment":null,"AddressId":8,"Id":1},{"Name":"Warehouse 88","AdminComment":null,"AddressId":186,"Id":2}]`;
	localStorage.setItem("stores", config.STORES);
}

config.WELCOME_IMAGES_PATH = `${config.ESTORIS_BASE_PATH}/content/images/welcome`;
config.FEATURED_IMAGES_PATH = `${config.ESTORIS_BASE_PATH}/content/images/featured`;

export default config;
